import type { JSX } from 'react';

import { Info } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

// Mismo patrón que FieldInfo del form de escenarios: ⓘ con tooltip explicativo.
const InfoHint = ({ text }: { text: string }): JSX.Element => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span className="inline-flex cursor-help" tabIndex={0} aria-label={text}>
        <Info className="size-3.5 text-text-muted/70" aria-hidden />
      </span>
    </TooltipTrigger>
    <TooltipContent side="top" className="max-w-[280px]">
      {text}
    </TooltipContent>
  </Tooltip>
);

export default InfoHint;
